import React, { useState } from "react";
import { CommonFilters, CustomTextField, DeliverablesFilter, FiltersWrapper } from "../../../../common/components";
import { isSegFeatureEnabled, SegFlags, translate } from "../../../../common/providers";
import styles from "./Filters.module.css";
import { debounce } from "../../../../common/utils";

const debounceFunc = debounce((func) => func(), 500);
const Filters = ({ filters, onChangeFilters }) => {
	const [textFilter, setTextFilter] = useState(filters?.content || "");
	const handleChangeTextFilter = (e) => {
		const { value } = e.target;
		setTextFilter(value);
		debounceFunc(() => {
			onChangeFilters({ ...filters, content: e.target.value });
		});
	};
	return (
		<div>
			<CustomTextField
				fullWidth
				multiline
				className={styles.textField}
				maxRows={5}
				placeholder={translate("children-requirements.filter.search")}
				value={textFilter}
				onChange={handleChangeTextFilter}
			/>
			<FiltersWrapper
				multiline
				components={[
					{
						default: true,
						enabled: isSegFeatureEnabled(SegFlags.DELIVERABLES),
						component: CommonFilters.DELIVERABLES,
						hasIsSeparator: false,
						hasAndOrOperator: false,
						renderer: <DeliverablesFilter />,
					},
					{
						default: true,
						enabled: true,
						labelKey: "label",
						valueKey: "key",
						component: CommonFilters.IMPACT,
					},
				]}
				defaultFilters={filters}
				onApply={onChangeFilters}
			/>
		</div>
	);
};

export default Filters;
